import * as Y from 'yjs';
import {prosemirrorJSONToYDoc, yDocToProsemirrorJSON} from 'y-prosemirror';
import {editorSchema} from '../core/schema';
import {isSubstantivePmJson} from '../../../features/collection/pmJsonContent';

export function readYjsPmJson(ydoc, fragmentKey = 'prosemirror') {
    if (!(ydoc instanceof Y.Doc)) {
        return null;
    }
    try {
        return yDocToProsemirrorJSON(ydoc, fragmentKey);
    } catch {
        return null;
    }
}

export function isYjsDocSubstantive(ydoc, fragmentKey = 'prosemirror') {
    return isSubstantivePmJson(readYjsPmJson(ydoc, fragmentKey));
}

/**
 * When collaboration sync yields an empty Y.Doc, seed it from a known-good PM JSON
 * snapshot (e.g. staged IIR body after submit/modify).
 */
export function seedYjsDocFromPmJsonIfEmpty(ydoc, pmJson, fragmentKey = 'prosemirror') {
    if (!(ydoc instanceof Y.Doc) || !isSubstantivePmJson(pmJson)) {
        return false;
    }
    if (isYjsDocSubstantive(ydoc, fragmentKey)) {
        return false;
    }

    ydoc.transact(() => {
        const target = ydoc.getXmlFragment(fragmentKey);
        while (target.length > 0) {
            target.delete(0, 1);
        }
    }, 'seed-from-pm-json');

    // `seeded` is a *separate* Y.Doc — its XmlFragment's items are owned by that doc and can't be
    // moved into `ydoc`'s fragment via insert()/toArray() (Yjs items are bound to the doc that
    // created them). Merge via the CRDT update stream instead: encode `seeded`'s full state and
    // apply it onto `ydoc`, which safely creates equivalent items under `ydoc`'s own identity.
    const seeded = prosemirrorJSONToYDoc(editorSchema, pmJson, fragmentKey);
    Y.applyUpdate(ydoc, Y.encodeStateAsUpdate(seeded), 'seed-from-pm-json');

    return true;
}
